<template lang="html">
  <div class="chosenanimal">
    <v-row justify=center>
      <v-col cols="7" md="4" @click="$router.push(`/animal/${animal.id}/`)">
        <div class="kiemeltvedenc">
          <h3 class="">Kiemelt védencünk</h3>
          <h4 class="display-1">{{animal.name}}</h4>
        </div>

        <v-img :src="animal.mainImage"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props:['animal'],
}
</script>

<style lang="scss" scoped>
.chosenanimal{
  margin-bottom: 30px;
}
.v-image{
  border-radius: 15px;
  border: 2px solid $lightbrown;

  &:hover{
    cursor: pointer;
    border-color: $darkbrown;
  }
}
.kiemeltvedenc{
  color: $darkbrown;
  text-align: center;
  margin-bottom: 10px;
}
</style>
